/*
 *   This content is licensed according to the W3C Software License at
 *   https://www.w3.org/Consortium/Legal/2015/copyright-software-and-document
 *
 *   ADA compliant accordion pattern with keyboard navigation
 */

'use strict';

class AccordionGroup {
  constructor(groupNode) {
    this.groupEl = groupNode;
    this.accordions = [];

    // Find all accordion items within this group
    const accordionItems = this.groupEl.querySelectorAll('.accordion h3');
    accordionItems.forEach((accordionEl) => {
      this.accordions.push(new Accordion(accordionEl, this));
    });
  }

  setFocusToNextAccordion(currentAccordion) {
    const index = this.accordions.indexOf(currentAccordion);
    if (index !== -1 && index < this.accordions.length - 1) {
      this.accordions[index + 1].buttonEl.focus();
    }
  }

  setFocusToPreviousAccordion(currentAccordion) {
    const index = this.accordions.indexOf(currentAccordion);
    if (index > 0) {
      this.accordions[index - 1].buttonEl.focus();
    }
  }

  setFocusToFirstAccordion() {
    if (this.accordions.length > 0) {
      this.accordions[0].buttonEl.focus();
    }
  }

  setFocusToLastAccordion() {
    if (this.accordions.length > 0) {
      this.accordions[this.accordions.length - 1].buttonEl.focus();
    }
  }
}

class Accordion {
  constructor(domNode, group) {
    this.rootEl = domNode;
    this.group = group;
    this.buttonEl = this.rootEl.querySelector('button[aria-expanded]');

    const controlsId = this.buttonEl.getAttribute('aria-controls');
    this.contentEl = document.getElementById(controlsId);

    this.open = this.buttonEl.getAttribute('aria-expanded') === 'true';

    // add event listeners
    this.buttonEl.addEventListener('click', this.onButtonClick.bind(this));
    this.buttonEl.addEventListener('keydown', this.onButtonKeyDown.bind(this));
  }

  onButtonClick() {
    this.toggle(!this.open);
  }

  onButtonKeyDown(event) {
    const key = event.key;
    let handled = false;

    switch (key) {
      case 'ArrowDown':
        this.group.setFocusToNextAccordion(this);
        handled = true;
        break;
      case 'ArrowUp':
        this.group.setFocusToPreviousAccordion(this);
        handled = true;
        break;
      case 'Home':
        this.group.setFocusToFirstAccordion();
        handled = true;
        break;
      case 'End':
        this.group.setFocusToLastAccordion();
        handled = true;
        break;
    }

    if (handled) {
      event.preventDefault();
      event.stopPropagation();
    }
  }

  toggle(open) {
    // don't do anything if the open state doesn't change
    if (open === this.open) {
      return;
    }

    // update the internal state
    this.open = open;

    // handle DOM updates
    this.buttonEl.setAttribute('aria-expanded', `${open}`);
    if (open) {
      this.contentEl.removeAttribute('hidden');
    } else {
      this.contentEl.setAttribute('hidden', '');
    }
  }

  // Add public open and close methods for convenience
  open() {
    this.toggle(true);
  }

  close() {
    this.toggle(false);
  }
}

// Init all accordions globally
document.querySelectorAll('.accordion h3').forEach((accordionEl) => {
  new Accordion(accordionEl, {
    setFocusToNextAccordion() {},
    setFocusToPreviousAccordion() {},
    setFocusToFirstAccordion() {},
    setFocusToLastAccordion() {}
  });
});

// Init accordion groups for keyboard navigation on collapsible-tabs sections
document.querySelectorAll('[data-section-type="collapsible-tabs"]').forEach((sectionEl) => {
  new AccordionGroup(sectionEl);
});

// Re-initialize accordions when store availability loads via AJAX
var storeAvailOuter = document.querySelector('.store-availability-container-outer');
if (storeAvailOuter) {
  new MutationObserver(function() {
    storeAvailOuter.querySelectorAll('.accordion h3:not([data-accordion-init])').forEach(function(accordionEl) {
      accordionEl.setAttribute('data-accordion-init', 'true');
      new Accordion(accordionEl, {
        setFocusToNextAccordion() {},
        setFocusToPreviousAccordion() {},
        setFocusToFirstAccordion() {},
        setFocusToLastAccordion() {}
      });
    });
  }).observe(storeAvailOuter, { childList: true, subtree: true });
}
